export const getCachedNewTest = () => {
  try {
    const cached = sessionStorage.getItem("newTest");
    if (cached) {
      return JSON.parse(cached);
    }
    return null;
  } catch (error) {
    console.error('Error reading cached new test:', error);
    return null;
  }
};

export const getCachedEditTests = () => {
  try {
    const cached = sessionStorage.getItem("editTests");
    if (cached) {
      return JSON.parse(cached);
    }
    return null;
  } catch (error) {
    console.error('Error reading cached edit tests:', error);
    return null;
  }
};

export const getCachedProfile = () => {
  try {
    const cached = sessionStorage.getItem("user_profile");
    if (cached) return JSON.parse(cached);
    return null;
  } catch (error) {
    console.error('Error reading cached profile:', error);
    return null;
  }
};

export const setCachedProfile = (profileData) => {
  try {
    sessionStorage.setItem("user_profile", JSON.stringify(profileData));
  } catch (error) {
    console.error('Error caching profile:', error);
  }
};

export const clearCachedProfile = () => {
  try {
    sessionStorage.removeItem("user_profile");
  } catch (error) {
    console.error('Error clearing cached profile:', error);
  }
};

export const getProfileData = (userFiles) => {
  try {
    if (!userFiles) return null;
    const profileFile = userFiles.find(file => file.key.includes('profile.json'));
    return profileFile ? profileFile.data : null;
  } catch (error) {
    console.error('Error reading profile data:', error);
    return null;
  }
};
